import { selectUpdated } from './postsFilters';

function initCustomSelects() {
  var x, i, j, l, ll, selElmnt, a, b, c;
  /* Look for any elements with the class "custom-select": */
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  
  for (i = 0; i < l; i++) {
    const selectedClass = x[i].hasAttribute("data-selected") ? ' select-items--selected' : '' ;
    selElmnt = x[i].getElementsByTagName("select")[0];
    const selectElementId = selElmnt.getAttribute('id');
    ll = selElmnt.length;

    /* Check if "select-selected" already exists */
    a = x[i].querySelector(".select-selected");
    if (!a) {
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      x[i].appendChild(a);
    }
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

    /* Check if "select-items" already exists */
    b = x[i].querySelector(".select-items");
    if (!b) {
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      x[i].appendChild(b);
    } else {
      b.innerHTML = ""; // Clear old options to prevent duplicates
    }

    /* Create the option items */
    for (j = 1; j < ll; j++) {
      c = document.createElement("DIV");
      c.setAttribute('data-value', selElmnt.options[j].getAttribute('value'));
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        /* When an item is clicked, update the original select box and the displayed text */
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
        if (this.dataset.value !== '' && this.dataset.value !== 'all' && this.dataset.value !== 'newest') {
          this.parentNode.classList.add('select-items--selected');
        } else {
          this.parentNode.classList.remove('select-items--selected');
        }
        handleSelectChange(selectElementId, this.dataset.value, c.innerHTML);
      });
      b.appendChild(c);
    }

    /* Ensure the click event is only added once */
    if (!a.hasAttribute("data-click-handler")) {
      a.addEventListener("click", function (e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
      a.setAttribute("data-click-handler", "true"); // Prevent duplicate event listeners
    }
  }
}




initCustomSelects();

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);


function handleSelectChange(selectId, selectedValue, selectedLabel) {
  console.log('handleSelectChange(' + selectId + '): val:' + selectedValue + ', label:' + selectedLabel);

  if( selectId.includes('subject-select') ) {
    console.log(`loc: ${selectId}: ${selectedValue}`);
    selectUpdated(selectId);
  }

  if( selectId.includes('topic-select') ) {
    console.log(`topic: ${selectId}: ${selectedValue}`);
    selectUpdated(selectId);
  }

  if( selectId.includes('grade-select') ) {
    console.log(`type: ${selectId}: ${selectedValue}`);
    selectUpdated(selectId);
  }

}

export {
  initCustomSelects
}